import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from "@vue/runtime-core";


export default /*#__PURE__*/_defineComponent({
  props: {
  value: String,
  lg: Boolean,
},
  setup(__props) {

const props = __props



const color = computed(() => {
  switch (props.value) {
    case "ORDERED":
      return "bg-blue-100 text-blue-800";

    case "HOLD":
      return "bg-indigo-100 text-indigo-800";

    case "RELEASED":
      return "bg-orange-100 text-orange-800";

    case "FULFILLED":
      return "bg-green-100 text-green-800";

    case "CANCELLED":
      return "bg-red-100 text-red-800";

    default:
      return "bg-gray-100 text-gray-800";
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["inline-flex items-center rounded-full font-medium", [__props.lg ? 'px-3 py-0.5 text-sm' : 'px-2.5 py-0.5 text-xs', _unref(color)]])
  }, _toDisplayString(__props.value), 3))
}
}

})